import { Component, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DossiersService } from '../../../services/dossiers/dossiers.service';
import { Dossiers_Data } from '../../../interfaces/Dossiers';
import { SharedService } from '../../../services/shared/shared.service';
import { BreadcrumbComponent } from "../../../common/breadcrumb/breadcrumb.component";
import { verif } from '../../../helpers/decorators/verif';
import { lazyComponents } from '../../../helpers/functions/LazyComponents';
import { LazyLoadable } from '../../../interfaces/LazyLoadable';

@Component({
    selector: 'app-dossier-details',
    standalone: true,
    templateUrl: './dossier-details.component.html',
    styleUrl: './dossier-details.component.css',
    imports: [CommonModule, BreadcrumbComponent]
})
export class DossiersDetailsComponent 
{
  @ViewChild('pagesContainer', { read: ViewContainerRef }) pagesContainer!: ViewContainerRef

  parent:string = 'Dossier'
  title!:string
  civilite!:string
  abonne!:string
  num_contrat1!:string
  num_contrat2!:string
  adresse!:string
  cp!:string
  ville!:string
  date!:Date
  date_realisation_previ!:Date
  // hors_delai!:number
  hors_delai!:Date
  etat!:string
  ref!:string
  id_dossier!:number
  id_user!:number
  imgSource:string = '/assets/icons/picto-transmettreenvoi-white.png'

  parentData!:Dossiers_Data

  readonly tabList = Object.freeze(["suivi","documents","messages","transmettre"])

  constructor
  (
    private sharedService: SharedService,
    private dossiersService: DossiersService,
    private activatedRoute: ActivatedRoute,
  ) 
  {
    this.ref = this.sharedService.getParam("ref")?.toString() || ""
    this.id_dossier = Number(this.sharedService.getParam("id_dossier"))
    this.id_user = this.sharedService.getIdUser()

    this.parentData = {ref:this.ref, id_dossier:this.id_dossier, type:"dossiers"}
  }

  ngOnInit()
  {
    this.activatedRoute.paramMap.subscribe(params => {
      this.title = `${this.parent} ${this.ref}`
      const id_dossier = this.activatedRoute.snapshot.queryParams['id_dossier']
      this.parentData.id_dossier = id_dossier
      this.getDetails({ref:this.ref, id_user:this.id_user, id_dossier:this.id_dossier})
    })
  }

  ngAfterViewInit() 
  {
    const onglet = localStorage.getItem("tab") || "suivi"

    if( onglet )
    {
      (document.querySelector(`#${onglet}`) as HTMLButtonElement).click()
    }
  }

  @verif()
  getDetails(params:{ref:string, id_user:string|number, id_dossier:number})
  {
    this.dossiersService.getDetails(params.ref, params.id_user).subscribe(data => {
      this.civilite = data[0].civilite
      this.abonne = data[0].abonne
      this.num_contrat1 = data[0].num_contrat1
      this.num_contrat2 = data[0].num_contrat2
      this.adresse = data[0].adresse
      this.cp = data[0].cp
      this.ville = data[0].ville
      this.date = data[0].date
      this.date_realisation_previ = data[0].date_realisation_previ
      this.etat = data[0].etat
      this.hors_delai = data[0].hors_delai
    })
  }

  changeSource()
  {
    this.imgSource = '/assets/icons/picto-transmettreenvoi-white.png'

  }

  defaultSource()
  {
    this.imgSource = '/assets/icons/picto-transmettre-black.png'
  }

  async changeTab(tab:string)
  {
    if(this.tabList.includes(tab))
    {
      await this.lazyLoadComponent(tab)
    }
  }

  async lazyLoadComponent(tab:string)
  {
    this.pagesContainer.clear()

    const loader = lazyComponents[tab]
    if (!loader) return

    localStorage.setItem("tab", tab)

    const ComponentClass = await loader()

    const componentRef: ComponentRef<LazyLoadable> = this.pagesContainer.createComponent(ComponentClass)

    componentRef.instance.data = this.parentData

    if(tab == "transmettre")
    {
      componentRef.instance.ref = this.ref
      componentRef.instance.id_dossier = this.id_dossier
    }
  }
}
